// Centralized DNCM Vision contact info.
export const CONTACT = {
  whatsappNumber: "33651579501", // international format, no '+', no spaces
  email: "dncmsolutions@gmail.com",
  brand: "DNCM Vision",
};

export const buildWhatsAppLink = (message) => {
  const text = encodeURIComponent(
    message ||
      "Bonjour DNCM Vision, je souhaite découvrir votre plateforme d'agents IA."
  );
  return `https://wa.me/${CONTACT.whatsappNumber}?text=${text}`;
};

export const buildMailtoLink = (subject, body) => {
  const s = encodeURIComponent(subject || "Demande d'information — DNCM Vision");
  const b = encodeURIComponent(
    body ||
      "Bonjour, je suis intéressé(e) par la plateforme d'agents IA DNCM Vision."
  );
  return `mailto:${CONTACT.email}?subject=${s}&body=${b}`;
};
